import React from "react";

// Port 1:1 de l'icône mobile (OLTODO/components/FilterIcon.tsx) — mêmes tracés, même viewBox
// 24×24. Glyphe "égaliseur" (trois lignes, un curseur décalé sur chacune) plutôt que le classique
// entonnoir — plus moderne, et le décalage des curseurs se prête bien à un point plein coloré
// pour signaler "des filtres sont actifs" sans badge séparé.
type IconProps = { size?: number; color?: string };

export const TuneIcon = ({ size = 20, color = "#0a0a0a" }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <line x1="4" y1="6" x2="20" y2="6" />
    <circle cx="9" cy="6" r="2" fill={color} stroke="none" />
    <line x1="4" y1="12" x2="20" y2="12" />
    <circle cx="17" cy="12" r="2" fill={color} stroke="none" />
    <line x1="4" y1="18" x2="20" y2="18" />
    <circle cx="13" cy="18" r="2" fill={color} stroke="none" />
  </svg>
);

export const ChevronDownIcon = ({ size = 14, color = "#0a0a0a" }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round">
    <line x1="6" y1="9" x2="12" y2="15" />
    <line x1="12" y1="15" x2="18" y2="9" />
  </svg>
);
